// Mobile meny click event
var menuButton = document.querySelector('.mobile-menu .menu-button')
var headerMain = document.querySelector('.site-header')
var navMenu = document.querySelector('.navigation-section')

menuButton.addEventListener('click', function() {
  navMenu.classList.toggle('open')
  menuButton.classList.toggle('active')
  headerMain.classList.toggle('meny-active')
});

// Mobile menu open child menu (used for lagngages)
var itemHasChild = document.querySelector('.secoundary-navigation .pll-parent-menu-item')
var openChild = document.querySelector('.secoundary-navigation .pll-parent-menu-item .sub-menu')

if(itemHasChild){
  itemHasChild.addEventListener('click', function() {
    openChild.classList.toggle('open')
    itemHasChild.classList.toggle('active')
  });
}

// Custom popup for reference images
var imageButton = document.querySelector('.image-popup-button')
var openPopup = document.querySelector('.custom-popup-reference-images')
var closeButton = document.querySelector('.custom-popup-reference-images .close-button')

if(imageButton){
  imageButton.addEventListener('click', function() {
    openPopup.classList.toggle('open')
  });
}

if(closeButton){
  closeButton.addEventListener('click', function() {
    openPopup.classList.toggle('open')
  });
}



